module.exports = __webpack_public_path__ + "images/ic-feature-header-1024-a218fdf157ab218efebc7993d87e065a.png";